import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconBellFilled = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path d="M13.2866 17.009C13.5916 17.05 13.8639 17.2303 14.02 17.5012C14.1983 17.8111 14.1984 18.193 14.019 18.5022C13.6017 19.2216 12.8322 19.6642 12.0005 19.6643C11.2209 19.6643 10.4965 19.2751 10.0649 18.634L9.98193 18.5022C9.8025 18.1929 9.80252 17.8111 9.98096 17.5012C10.1595 17.1914 10.4896 17.0002 10.8472 17.0002H13.1538L13.2866 17.009ZM12.0005 4.33325C15.13 4.33343 17.6665 6.87074 17.6665 10.0002V13.3333C17.6665 13.8511 18.0605 14.2773 18.5649 14.3284L18.6665 14.3333L18.769 14.3381C19.2733 14.3893 19.6665 14.8155 19.6665 15.3333C19.6665 15.851 19.2733 16.2772 18.769 16.3284L18.6665 16.3333H5.3335C4.78121 16.3333 4.3335 15.8855 4.3335 15.3333C4.3335 14.8156 4.72683 14.3895 5.23096 14.3381L5.43604 14.3284C5.94016 14.277 6.3335 13.8509 6.3335 13.3333V10.0002C6.3335 6.87063 8.87087 4.33325 12.0005 4.33325Z" />
      </svg>
    );
  }
);
